<div class="filter-container" (click)="$event.stopPropagation()">
  <wpbutton class="-secondary filter-btn" (click)="toggleDropdown($event)">
    Filter
    <span [class.open]="isOpen">
      <lucide-icon [name]="isOpen ? 'chevron-up' : 'chevron-down'" [size]="16" class="-lucide-icon"></lucide-icon>
    </span>
  </wpbutton>
  <button type="button" class="responsive-filter-button" (click)="toggleDropdown($event)" aria-label="Filter results">
    <lucide-icon name="settings-2" [size]="16"></lucide-icon>
  </button>
  @if (isOpen) {
  <div class="dropdown" (click)="$event.stopPropagation()">
    <div class="option" [class.disabled]="allResult.disabled" (click)="handleOptionClick(allResult, $event)">
      <input
        type="checkbox"
        id="all-result-checkbox"
        [checked]="allResult.checked"
        [disabled]="allResult.disabled"
        tabindex="-1" />
      <label for="all-result-checkbox"> {{ allResult.label }} ({{ allResult.count }}) </label>
    </div>
    @for (option of filterOptions; track option) {
    <div class="option" [class.disabled]="option.disabled" (click)="handleOptionClick(option, $event)">
      <input
        type="checkbox"
        [id]="'option-checkbox-' + option.label"
        [checked]="option.checked"
        [disabled]="option.disabled"
        tabindex="-1" />
      <label [for]="'option-checkbox-' + option.label" [class.disabled]="option.disabled">
        {{ option.label }} ({{ option.count }})
      </label>
    </div>
    }
  </div>
  }
</div>
